import axios from '@axios';
import { ErrorMessage } from '@/libs/Error';

export default class S3BucketClient {
  constructor() {
    this.api = axios;
    this.error = new ErrorMessage();
  }

  async postS3Upload(formtData) {
    try {
      const { data } = await this.api.post('/s3/upload', formtData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      });
      return data;
    } catch (error) {
      throw this.error.message(error, 'Error ao fazer upload da imagem');
    }
  }
}
